export function getJobHash(job: { hash?: string }, length = 10) {
  if (job.hash) {
    return job.hash
  }

  const sanitizedJobString = encodeURIComponent(JSON.stringify(job))
  return window.btoa(sanitizedJobString).slice(0, length)
}
